import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'every'
})
export class EveryPipe implements PipeTransform {
  transform<T, K>(arr: T[], fn: (el: T, index?: number, array?: T[]) => K): boolean {
    return arr.length > 0 && arr.every(fn);
  }
}
